import React, { useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import downloadIconDefault from '../../../images/insight360/download-icon_default.png';
import { useSelector, useDispatch } from '../../common/react-redux-hooks';
import { setRldCurrentView } from '../../../actions/rldToolActions';
import { RLD_VIEW_NEW_REQUEST } from '../RldConstant';
import { getRldList } from '../../../actions/rldToolActions';

import {
  RldLibrarySection,
  RldLibraryContainer,
  RldLibraryHeading,
  RldLibraryNewRequestLinkWrapper,
  RldLibraryNewRequestLink,
  RldLibraryDataGrid,
  RldLibraryRow,
  RldGridHeadCell,
  RldGridHeadFirstCell,
  RldGridHeadLastCell,
  RldGridTableContainer,
  RldGridCell,
  RldGridFirstCell,
} from './styledComponents';
import GenericButton from '../../common/GenericButton';

const RldLibraryList = () => {
  const dispatch = useDispatch();
  const rldList = useSelector(({ rldTool }) => rldTool.rldList);

  const handleNewRequest = () => {
    dispatch(setRldCurrentView(RLD_VIEW_NEW_REQUEST));
  };

  // Get RLD list data
  useEffect(() => {
    if (rldList.length === 0) {
      dispatch(getRldList());
    }
  }, []);

  return (
    <RldLibrarySection>
      <RldLibraryContainer>
        <RldLibraryRow>
          <RldLibraryHeading>RLD Library</RldLibraryHeading>
          <RldLibraryNewRequestLinkWrapper>
            <div className="button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add-new btn-priaryDisable"
                onBtnClick={handleNewRequest}
              />
            </div>
            <RldLibraryNewRequestLink onClick={handleNewRequest}>
              New RLD Request
            </RldLibraryNewRequestLink>
          </RldLibraryNewRequestLinkWrapper>
        </RldLibraryRow>
        <RldLibraryRow>
          <RldLibraryDataGrid>
            <RldGridTableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <RldGridHeadFirstCell>Study</RldGridHeadFirstCell>
                    <RldGridHeadCell>Date</RldGridHeadCell>
                    <RldGridHeadCell>File Type</RldGridHeadCell>
                    <RldGridHeadCell>Recepient</RldGridHeadCell>
                    <RldGridHeadCell>Status</RldGridHeadCell>
                    <RldGridHeadLastCell>Link</RldGridHeadLastCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rldList.length &&
                    rldList.map(row => (
                      <TableRow key={row.id}>
                        <RldGridFirstCell component="th" scope="row">
                          {row.studyName}
                        </RldGridFirstCell>
                        <RldGridCell>{row.createDate}</RldGridCell>
                        <RldGridCell>{row.reportType}</RldGridCell>
                        <RldGridCell>{row.recepients}</RldGridCell>
                        <RldGridCell>{row.statusDesc}</RldGridCell>
                        <RldGridCell>
                          {row.downloadLink && (
                            <a href={row.downloadLink} download>
                              <button
                                type="button"
                                className="export-icon-class"
                              >
                                <img alt="" src={downloadIconDefault} />
                              </button>
                            </a>
                          )}
                        </RldGridCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </RldGridTableContainer>
          </RldLibraryDataGrid>
        </RldLibraryRow>
      </RldLibraryContainer>
    </RldLibrarySection>
  );
};

export default RldLibraryList;
